import UsageTrackerContainer from './UsageTrackingContainer';
import AnonymousUsageTrackerContainer from './AnonymousUsageTrackerContainer';
import { getQueryParam } from '../routing/getQueryParam';
import UTMS_ANONYMOUS_TRACKING from '../constants/utmMediumAnonymousTracking';
export const hasTrackingBeenEnabled = () => {
  return UsageTrackerContainer.identifiableTrackingEnabled || AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled;
};
export const getHasTrackingByUuid = () => {
  const utmMedium = getQueryParam('utm_medium');
  const useUuid = getQueryParam('use_uuid');
  return UTMS_ANONYMOUS_TRACKING.includes(utmMedium) && useUuid === '1';
};